import popupEnum from "@/enums/popupEnum";
import ChatPopup from "@/components/View/ChatPopup/ChatPopup";
import ConfirmPopup from "@/components/View/ConfirmPopup/ConfirmPopup";

const popupMap = {
  [popupEnum.CHAT_POPUP]: ChatPopup,
  [popupEnum.CONFIRM_POPUP]: ConfirmPopup,
};

const state = {
  popupName: "",
  popupMap,
  popupContext: {},
};

const getters = {
  getPopup: (state) => (popupName) => {
    return state.popupMap[popupName];
  },
  getPopupContext: (state) => (popupName) => {
    return state.popupContext;
  },
  isPopupOpen: (state) => (popupName) => {
    return state.popupName === popupName;
  },
};

const actions = {
  async openPopup({ commit }, payload) {
    const { popupName, popupContext = {} } = payload;
    commit("setCurrentPopup", popupName);
    commit("setPopupContext", popupContext);
  },
};

const mutations = {
  setCurrentPopup(state, popupName) {
    state.popupName = popupName;
  },
  setPopupContext(state, popupContext) {
    state.popupContext = popupContext;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
